import { MULTISTATE_GAMES, STATE_GAMES, type Game } from "./games";

export interface JackpotSnapshot {
  id: string;
  game_id: string;
  jackpot_amount: number;
  cash_value: number | null;
  next_draw_datetime: string;
  games?: Game & { states?: any };
}

function nextDraw(daysAhead: number, hour = 22, minute = 59) {
  const d = new Date();
  d.setDate(d.getDate() + daysAhead);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
}

const JP_BY_SLUG: Record<string, { jackpot: number; cash: number | null; days: number }> = {
  powerball: { jackpot: 285_000_000, cash: 134_500_000, days: 2 },
  "mega-millions": { jackpot: 162_000_000, cash: 73_400_000, days: 3 },
  "lucky-for-life": { jackpot: 0, cash: 7_000_000, days: 1 },
  cash4life: { jackpot: 0, cash: 7_000_000, days: 1 },
  "lotto-america": { jackpot: 4_220_000, cash: 2_100_000, days: 2 },
  "new-york-lotto": { jackpot: 5_300_000, cash: null, days: 3 },
  "california-superlotto-plus": { jackpot: 18_000_000, cash: 9_500_000, days: 4 },
  "texas-lotto-texas": { jackpot: 12_750_000, cash: 7_100_000, days: 2 },
  "florida-florida-lotto": { jackpot: 6_500_000, cash: 4_100_000, days: 4 },
  "illinois-lotto": { jackpot: 7_250_000, cash: null, days: 2 },
  "pennsylvania-match-6": { jackpot: 1_900_000, cash: null, days: 1 },
  "ohio-classic-lotto": { jackpot: 21_500_000, cash: null, days: 2 },
  "michigan-lotto-47": { jackpot: 3_100_000, cash: null, days: 3 },
  "new-jersey-pick-6": { jackpot: 4_300_000, cash: null, days: 4 },
  "arizona-the-pick": { jackpot: 2_400_000, cash: null, days: 2 },
  "washington-lotto": { jackpot: 5_100_000, cash: null, days: 3 },
  "colorado-lotto-plus": { jackpot: 3_750_000, cash: null, days: 4 },
  "massachusetts-megabucks-doubler": { jackpot: 1_600_000, cash: null, days: 2 },
};

function buildSnap(g: Game): JackpotSnapshot {
  const entry = JP_BY_SLUG[g.slug] ?? { jackpot: 0, cash: null, days: 2 };
  return {
    id: `jp-${g.id}`,
    game_id: g.id,
    jackpot_amount: entry.jackpot,
    cash_value: entry.cash,
    next_draw_datetime: nextDraw(entry.days),
    games: g as any,
  };
}

export const JACKPOT_SNAPSHOTS: JackpotSnapshot[] = [
  ...MULTISTATE_GAMES.map(buildSnap),
  ...STATE_GAMES.map(buildSnap),
];